var _rect, _path, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6316 28.0491C26.6582 29.7125 24.0984 30.7166 21.3011 30.7166C15.0597 30.7166 10 25.7171 10 19.55C10 13.3828 15.0597 8.3833 21.3011 8.3833C24.0984 8.3833 26.6582 9.38746 28.6316 11.0509C30.605 9.38746 33.1649 8.3833 35.9621 8.3833C42.2036 8.3833 47.2632 13.3828 47.2632 19.55C47.2632 25.7171 42.2036 30.7166 35.9621 30.7166C33.1649 30.7166 30.605 29.7125 28.6316 28.0491Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6318 28.0491C31.0617 26.0009 32.6025 22.9532 32.6025 19.55C32.6025 16.1467 31.0617 13.099 28.6318 11.0509C30.6053 9.38746 33.1651 8.3833 35.9623 8.3833C42.2038 8.3833 47.2635 13.3828 47.2635 19.55C47.2635 25.7171 42.2038 30.7166 35.9623 30.7166C33.1651 30.7166 30.6053 29.7125 28.6318 28.0491Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6318 28.0489C31.0616 26.0007 32.6024 22.9531 32.6024 19.5498C32.6024 16.1466 31.0616 13.099 28.6318 11.0508C26.2019 13.099 24.6611 16.1466 24.6611 19.5498C24.6611 22.9531 26.2019 26.0007 28.6318 28.0489Z",
    fill: "#FF5E00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    stroke: "#F2F4F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.5b2313a5a3452bf112c3f9143f9586b8.svg";
export { ForwardRef as ReactComponent };